import type { BranchCategory } from '@festina/configuration-general-types/configuration'
import type { Except, Optional } from '@festina-life/core'
import { Icon } from '@festina-life/ui/structure'
import type { ComponentProps } from 'react'

import { CategoryToIconMap } from './helpers'

type Props = {
  category: Optional<BranchCategory>
} & Except<ComponentProps<typeof Icon>, 'name' | 'size'>

export const BranchCategoryIcon = ({ category, ...iconsProps }: Props) => {
  const iconName = category ? CategoryToIconMap[category] : null

  return iconName ? (
    <Icon {...iconsProps} size="sm" name={iconName} className="text-inherit!" />
  ) : null
}
